import ComicCard from '@/components/base/ComicCard';
import { getHotComics } from '@/mocks/comics';

export default function HotRecommendSection() {
  const hotComics = getHotComics();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <p className="text-accent-400 font-label text-xs tracking-[0.2em] uppercase mb-2">
              本周热推
            </p>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              精选无删减韩国漫画下拉式阅读
            </h2>
          </div>
          <a
            href="/category/action"
            className="text-sm text-primary-500 font-label hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}